export const testimonials = [
  {
    id: 'clara',
    quote: 'Every frame felt intentional, but the shoot itself never felt forced. The final campaign felt unmistakably like us.',
    name: 'Clara Jensen',
    role: 'Creative Director',
    brand: 'Noma Studio',
  },
  {
    id: 'tomas',
    quote: 'Clear direction, calm energy, and images that immediately gave the brand more personality. Our team still talks about how easy the day felt.',
    name: 'Tomás Ribeiro',
    role: 'Head of Brand',
    brand: 'Atelier Lume',
  },
  {
    id: 'hannah',
    quote: 'The work felt polished without losing the spontaneity we wanted from the people in front of the camera.',
    name: 'Hannah Weiss',
    role: 'Photo Editor',
    brand: 'Form Quarterly',
  },
];